import { dataPopupOldPage } from '@/contracts/oldPage'

function isInternalUrl(input) {
  return !!input && /^\/(?!\/)/.test(input)
}

export default function (ctx) {
  const { route, store, redirect, from } = ctx
  const query = route.query
  if (query.toast) {
    const {
      toast = '',
      description = '',
      linkTitle = '',
      linkUrl = '',
      isBrowserPopup = null,
    } = query
    const data: dataPopupOldPage = {
      toast,
      description,
      linkTitle,
      linkUrl,
      isBrowserPopup,
    }

    const togglePopup = () => {
      setTimeout(() => {
        store.commit('oldPage/SET_DATA_POPUP', data)
        store.commit('oldPage/TOGGLE_POPUP', true)
      }, 0)
    }

    if (from) {
      togglePopup()
      redirect(from.path)
    } else if (linkUrl.startsWith('http')) {
      try {
        const url = new URL(linkUrl)
        const parts = url.hostname.split('.')
        const domain = `${parts[parts.length - 2]}.${parts[parts.length - 1]}`
        if (domain === 'rgs.ru') {
          togglePopup()
          redirect(linkUrl)
        }
      } catch (e) {
        console.error('OLD PAGE REDIRECT ERROR:', e)
      }
    } else if (isInternalUrl(linkUrl)) {
      togglePopup()
      redirect(linkUrl)
    }
  }
}
